import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../firebaseConfig";
import "../Login.css"; // Asegúrate de tener estilos

function Login() {
  const [cuit, setCuit] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    // Al montar el componente Login
    document.body.className = "login-body";

    // Al desmontar (cuando vamos al portal)
    return () => {
      document.body.className = ""; // Limpiamos
    };
  }, []);

  // Función para obtener el email asociado al CUIT
  const fetchEmailByCUIT = async (cuit) => {
    try {
      const response = await fetch("/api/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ cuit, password }), // Se envía el CUIT y la contraseña
      });

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.error);
      }

      // Guardar CUIT en localStorage
      localStorage.setItem("cuit", data.cuit);

      return data.email; // Devuelve el email encontrado en Sheets
    } catch (error) {
      setError(error.message);
      throw error;
    }
  };

  // Iniciar sesión con Firebase
  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
  
    try {
      // 1️⃣ Buscar email en Google Sheets con el CUIT
      const email = await fetchEmailByCUIT(cuit);
  
      // 2️⃣ Iniciar sesión en Firebase con email + password
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
  
      // 3️⃣ Verificar si el correo fue confirmado
      if (!user.emailVerified) {
        alert("⚠️ Debés verificar tu correo electrónico antes de ingresar al portal.");
        return;
      }
  
      // 4️⃣ Si está verificado, navegar al portal
      navigate("/home");
  
    } catch (error) {
      console.error("❌ Error al iniciar sesión:", error);
      setError("Error al iniciar sesión: " + error.message);
    }
  };

  // Recuperar contraseña con Firebase
  const handleResetPassword = async () => {
    if (!cuit) {
      alert("Por favor, ingresa tu CUIT para recuperar la contraseña.");
      return;
    }

    try {
      const email = await fetchEmailByCUIT(cuit);
      await sendPasswordResetEmail(auth, email);
      alert("Se ha enviado un correo de recuperación.");
    } catch (error) {
      alert("Error al enviar correo de recuperación: " + error.message);
    }
  };

  // Abrir el instructivo de uso en Drive
  const handleOpenManual = () => {
    window.open("https://drive.google.com/file/d/1ooYEaUXG06whPAhD3q0eS3OQUiemVlXp/view", "_blank");
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <img src="sinec_logo_sidebar.png" alt="Logo" className="logo" />
        <h3>Iniciar Sesión</h3>
        <form onSubmit={handleLogin}>
          <input
            type="text"
            placeholder="CUIT"
            value={cuit}
            onChange={(e) => setCuit(e.target.value)}
            required
            className="login-input"
          />
          <input
            type="password"
            placeholder="Contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="login-input"
          />
          <button type="submit">Ingresar</button>
        </form>

        {error && <p style={{ color: "red", fontSize: "12px" }}>Error al iniciar sesión: CUIT o contraseña inválido.</p>}

        {/* Botón de Recuperar Contraseña */}
        <button onClick={handleResetPassword} className="btn-link">
          Recuperar Contraseña
        </button>

        {/* Contenedor para "Registrarse" e "Instructivo de Uso" */}
        <div className="btn-group">
          <button onClick={() => navigate("/register")}>Registrarse</button>
          <button onClick={handleOpenManual}>Instructivo</button>
        </div>
      </div>
    </div>
  );
}

export default Login;


